export default __webpack_public_path__ + "static/media/crown_4.2332ab66.png";